import { render, staticRenderFns } from "./dialog-confirm.component.vue?vue&type=template&id=189c0158"
import script from "./dialog-confirm.component.vue?vue&type=script&lang=ts"
export * from "./dialog-confirm.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports